import React, { useCallback, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import CpanelPageShell from '../../../components/cpanel/CpanelPageShell';
import DatatableCpanelLogs from '../../../components/moleculs/cpanel/logs/datatable';
import ShowCpanelLogComp from '../../../components/moleculs/cpanel/logs/show';
import { CPANEL_FEED_REFRESH_EVENT } from '../../../helpers/cpanelJobFeedback';

const CpanelLogsPage = () => {
  const [search, setSearch] = useState('');
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLog, setShowLog] = useState(null);
  const [lgShowDetail, setLgShowDetail] = useState(false);
  const [paginationMeta, setPaginationMeta] = useState({
    total: 0,
    page: 1,
    limit: 25,
    totalPages: 1,
  });

  const fetchLogs = useCallback(async (page = 1, limit = 25, keyword = '', options = {}) => {
    const { silent = false } = options;
    if (!silent) {
      setLoading(true);
    }
    try {
      const { data } = await axios({
        url: '/cpanel/activity/list',
        method: 'GET',
        params: {
          page,
          limit,
          search: keyword,
        },
      });

      setLogs(data?.data || []);
      setPaginationMeta((prev) => data?.meta || { ...prev, total: 0, page: 1, limit, totalPages: 1 });
    } catch (err) {
      console.log(err);
      if (!silent) {
        MySwal.fire({
          icon: 'error',
          title: 'Gagal memuat log',
          text: err?.response?.data?.message || 'Tidak dapat mengambil daftar aktivitas.',
        });
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const handleShowLog = async (row) => {
    try {
      const { data } = await axios({
        url: `/cpanel/activity/show/${row.id}`,
        method: 'GET',
      });
      setShowLog(data);
      setLgShowDetail(true);
    } catch (err) {
      MySwal.fire({
        icon: 'error',
        title: 'Gagal',
        text: err?.response?.data?.message || 'Tidak dapat memuat detail log.',
      });
    }
  };

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const handleChangePage = (page) => {
    fetchLogs(page, paginationMeta.limit, search);
  };

  const handleChangePerPage = (limit, page) => {
    fetchLogs(page, limit, search);
  };

  useEffect(() => {
    const timer = window.setTimeout(() => {
      fetchLogs(1, paginationMeta.limit, search);
    }, search ? 350 : 0);

    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    const onRefresh = () =>
      fetchLogs(paginationMeta.page, paginationMeta.limit, search, { silent: true });
    window.addEventListener(CPANEL_FEED_REFRESH_EVENT, onRefresh);
    return () => window.removeEventListener(CPANEL_FEED_REFRESH_EVENT, onRefresh);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationMeta.page, paginationMeta.limit, search]);

  return (
    <>
      <CpanelPageShell
        title="Log"
        subtitle="Riwayat aktivitas CPanel"
        breadcrumbs={[
          { label: 'CPanel', to: '/cpanel/dashboard' },
          { label: 'Activity' },
          { label: 'Log' },
        ]}
      >
        <div className="card cpanel-card">
          <div className="card-body cpanel-tenants-card-body">
            <DatatableCpanelLogs
              listLogs={logs}
              search={search}
              handleChangeSearch={handleChangeSearch}
              handleShowLog={handleShowLog}
              loading={loading}
              paginationMeta={paginationMeta}
              onChangePage={handleChangePage}
              onChangePerPage={handleChangePerPage}
            />
          </div>
        </div>
      </CpanelPageShell>

      <Modal
        show={lgShowDetail}
        onHide={() => setLgShowDetail(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail Log Aktivitas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ShowCpanelLogComp activity={showLog} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CpanelLogsPage;
